// extracted by mini-css-extract-plugin
module.exports = {"fileStyle":"index_fileStyle__2HenW","nameShow":"index_nameShow__2Fsck","uploadTips":"index_uploadTips__2K6lb","errorStyle":"index_errorStyle__Azp84"};